import React, { useEffect } from "react";
import Xraycon from "./Xraycon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Xray() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Xraycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best X-Ray Centre in Whitefield</title>
        <meta
          name="description"
          content="We are the best X-Ray Centre in Whitefield and Vijayanagar. If you are looking for this, feel free to contact us today or call us."
        />
        <meta
          name="keywords"
          content="Best X-Ray Centre in Whitefield, Best X-Ray Centre in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/bestxrayinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestxrayinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers professional X-ray imaging services including chest X-rays, bone imaging, joint and extremity evaluations, and diagnostic support by skilled radiology technicians to help doctors diagnose conditions accurately.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "X-ray imaging services",
              "Chest X-ray examination",
              "Bone and joint imaging",
              "Extremity X-ray scans",
              "Diagnostic radiology support",
              "Fracture detection imaging",
              "Orthopedic X-ray evaluation",
            ],
            keywords: [
              "best xray in Immadihalli",
              "best xray in Whitefield",
              "best xray in Bangalore",
              "best xray in Kundalahalli",
              "best xray in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Best X-Ray Centre in Whitefield contributing to the overall well-being
        of our patients. Contact us for the best X Ray Centre in Whitefield
      </h2>
      <Servicebanner name="X ray" banner={"../photo/dd26.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Xray;
